// extracted by mini-css-extract-plugin
export default {"avatarBtn":"avatar_avatarBtn__FM-q2","avatarFallback":"avatar_avatarFallback__gzj2-"};